<template>
  <my_public_index
    :module="module"
    :column="column"
    :moduleIndex="module_index"
  >
    <template #content>
      <empty-tips
        :empty_tips_show="listArr.content === '' && listArr.type === 'default'"
        @handleClick="tipsClick"
        type="empty_tips"
        :empty_tips_text="$t('widgets_basic_plugin_code_index_2739')"
        :empty_tips_btn_name="$t('widgets_basic_plugin_code_index_2740')"
      />
      <empty-tips
        :tips_text="p[`${listArr.id}_textTips`]"
        :tips_text_spec="p[`${listArr.id}_tipsTextSpec`]"
        :tips_show="listArr.type !== 'default' || (listArr.type === 'default' && listArr.content !== '')"
        @handleClick="tipsClick"
        type="tips"
      />
      <div
        :data-note="listArr.note"
        class="iframe-content"
        v-append="htmlContent"
        v-show="listArr.content !== '' && listArr.type === 'default'"
      ></div>
    </template>
  </my_public_index>
</template>

<script>
import i18n from '../../language/index'

import Cookies from 'js-cookie';
import { emptyTips } from "@/widgets/basic_plugin_code/components";
import p from "./p";

export default {
  name: "basic_plugin_code",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  components: { emptyTips },
  data () {
    return {
      p
    };
  },
  computed: {
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor;
    },
    listArr () {
      return this.module.data.listArr;
    },
    htmlContent () {
      return this.listArr.content.replace(/<script\b.*?(?:>)/gi, '<script>');
    }
  },
  mounted () {
    this.init();
  },
  watch:{
    'listArr.content': {
      handler: function(val) {
        this.$nextTick(() => {
          let note = ''
          note += i18n.t('widgets_basic_plugin_code_index_2741') + JSON.stringify(window.returnCitySN)
          note += i18n.t('components_my_img_selecter_img_selecter_2332') + new Date()
          this.listArr.note = note
        });
      },
      deep: true
    }
  },
  created() {
    this.templet.checkNoteValue(this.listArr)
  },
  methods: {
    init () {
      this.listArr.id = this.module.widgets_id;
      this.p.changeTextTips.bind(this)(true);
    },
    tipsClick () {
      this.templet.changeStyle(this.module, "style");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/css/commonly.scss";
</style>

<style>
.iframe-content iframe {
    border: 0;
}
.mb_pattern .basic_plugin_code video {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_plugin_code/index.vue